/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Voice_TitleInputs */

const en_homepage_features_voice_title = /** @type {(inputs: Homepage_Features_Voice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the voice that matches you`)
};

const es_homepage_features_voice_title = /** @type {(inputs: Homepage_Features_Voice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la voz que mejor se adapte a ti`)
};

/**
* | output |
* | --- |
* | "Choose the voice that matches you" |
*
* @param {Homepage_Features_Voice_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_voice_title = /** @type {((inputs?: Homepage_Features_Voice_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Voice_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_voice_title(inputs)
	return en_homepage_features_voice_title(inputs)
});